import { useEffect, useRef, useState } from 'react';
import { productCategories } from '../../../mocks/productCategories';

export default function CertificationsSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full py-20 md:py-28 bg-stone-100 overflow-hidden"
    >
      <div
        className={`transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Title */}
        <div className="text-center mb-12 px-6">
          <p className="text-sm md:text-base text-gray-600 tracking-wide">
            Nuestros Productos
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-2">
            Explora nuestras categorías
          </h2>
        </div>

        {/* Categories Grid */}
        <div className="px-6 md:px-16 lg:px-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 max-w-7xl mx-auto">
            {productCategories.map((cat) => (
              <div
                key={cat.name}
                className="group relative block overflow-hidden rounded-lg bg-white"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-white text-sm md:text-base font-semibold text-center leading-tight">
                    {cat.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}